<template>
  <div :class="{'col-md-6 offset-md-3 col-12': newProp}">
    <form @submit.prevent="save">
      <v-row>
        <v-col cols="12" :class="{'col-md-6': !newProp}">
          <v-text-field
            v-model="emptyForm.name"
            label="Ime"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="!hideDescription">
        <v-col cols="12" :class="{'col-md-6': !newProp}">
          <v-text-field
            v-model="emptyForm.description"
            label="Opis"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="!hidetimes" :class="{'col-md-6': !newProp}">
        <v-col cols="6">
          <v-checkbox
            hide-details
            color="#0F998E"
            v-model="emptyForm.is_active"
            label="Aktiven"
          ></v-checkbox>
        </v-col>
        <v-col cols="6" class="text-end" style="display: flex;justify-content: end;align-items: end;">
          <p class="mb-0" style="cursor: pointer;text-decoration: underline;" @click="showPricingSetMainAcceptanceFormModal = true; pricingSetMainAcceptanceForm = pricingInfo">Uveljavi cene kot prodajne</p>
        </v-col>
      </v-row>
      <v-row v-if="!hidetimes" cols="12">
        <v-col cols="6">
          <h2>
            Veljavnost cenikov:
          </h2>
        </v-col>
        <v-col cols="6" style="display: flex; justify-content: end; align-items: end;">
          <v-btn @click="() => addNewTimeRowPopup('day')" class="white--text mr-4" color="#0F998E">
            DAN +
          </v-btn>
          <v-btn @click="() => addNewTimeRowPopup('date')" class="white--text" color="#0F998E">
            DATUM +
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!hidetimes">
        <v-col cols="12">
          <!-- {{ emptyFormDatesFormated }} -->
            <!-- :key="`${i}-${dateInput.startTime}-${dateInput.endTime}`" -->
          <v-row v-for="(dateInput, i) in emptyFormDatesFormated" :key="dateInput.key">
            <v-col class="d-flex justify-start align-center" cols="4" v-if="dateInput.type === 'day' && dateInput.days">
              <span class="text-uppercase text-bold mx-1" >
                {{ dateInput.days.name }}
              </span>
            </v-col>
            <v-col style="flex: 1;">
              <!--                 :key="`OD-i-${dateInput.startTime}`" -->
              <DateTimeSelector
                labelDate="Od"
                :date="dateInput.startDate"
                :time="dateInput.startTime"
                :onlyTime="dateInput.type  && dateInput.type === 'day'"
                @change="({ date, time }) => updateStartDateTime({ date, time, i})"
              />
            </v-col>
            <v-col style="flex: 1;">
              <!--                 :key="`DD-i-${dateInput.endTime}`" -->
              <DateTimeSelector
                labelDate="Do"
                :date="dateInput.endDate"
                :time="dateInput.endTime"
                :onlyTime="dateInput.type  && dateInput.type === 'day'"
                @change="({ date, time }) => updateEndDateTime({ date, time, i })"
              />
            </v-col>
            <v-col cols="auto" class="d-flex justify-center align-center">
              <ButtonActionDelete style @click="() => removeDateEntry(i)" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn v-if="!skrij" type="submit" class="float-right white--text" color="#0F998E">
            Naprej
          </v-btn>
          <v-btn v-if="!skrij" text type="button" class="float-right mr-4" @click="cancel">Prekliči</v-btn>
        </v-col>
      </v-row>
    </form>

    <MyCompanyBusinessUnitPricingDialog
      ref="mydialog"

    />

    <ConfirmDialog
      title="Uveljavi cene nivoja"
      text="Ali res uveljavim cene na nivoju kot prodajne?"
      okBtnText="Potrdi"
      v-model="showPricingSetMainAcceptanceFormModal"
      @confirmed="setPricingAsMainMethod(pricingSetMainAcceptanceForm)"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import ConfirmDialog from '@/components/ConfirmDialog'
import DateTimeSelector from '@/components/DateTimeSelector.vue'
import MyCompanyBusinessUnitPricingDialog from '@/components/MyCompanyBusinessUnitPricingDialog'
import ButtonActionDelete from '@/components/ButtonActionDelete'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    ButtonActionDelete,
    DateTimeSelector,
    ConfirmDialog,
    MyCompanyBusinessUnitPricingDialog,
  },
  props: {
    dates: {
      default: () => [],
      type: Object
    },
    name: {
      default: '',
      type: String
    },
    newProp: {
      default: false,
      type: Boolean
    },
    description: {
      default: '',
      type: String
    },
    isActive: {
      default: false,
      type: Boolean
    },
    skrij: {
      required: false,
      type: Boolean,
      default: false
    },
    hidetimes: {
      default: false,
      type: Boolean
    },
    hideDescription: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      emptyForm: {
        dates: [/* {
          startDate: moment().format('YYYY-MM-DD'),
          startTime: '00:00:00',
          endDate: moment().format('YYYY-MM-DD'),
          endTime: '23:59:59',
        } */],
        description: null,
        name: null,
        is_active: false
      },
      form: {},
      dataFetched: false,
      razlog: null,
      showPricingSetMainAcceptanceFormModal: false,
      pricingSetMainAcceptanceForm: null,
      daysOptions: [
        {
          name: 'ponedeljek',
          val: 1,
        },
        {
          name: 'torek',
          val: 2,
        },
        {
          name: 'sreda',
          val: 3,
        },
        {
          name: 'četrtek',
          val: 4,
        },
        {
          name: 'petek',
          val: 5,
        },
        {
          name: 'sobota',
          val: 6,
        },
        {
          name: 'nedelja',
          val: 7
        }
      ],
    }
  },
  validations: {
    form: {
      date: {
        required
      }
    }
  },
  computed: {
    isNewDates () {
      return !this.dates || Object.values(this.dates).length === 0
    },
    emptyFormDatesFormated () {
      return this.emptyForm.dates
    }
  },
  methods: {
    guid () {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
    },
    setPricingAsMainMethod (item) {
      this.$emit("setPricingRequest")
    },
    removeDateEntry (indx) {
      this.emptyForm.dates.splice(indx, 1)
    },
    async addNewTimeRowPopup (typeOfPopup) {
      const returnedDates = await this.$refs.mydialog.open(typeOfPopup)
      if (returnedDates) {
        this.emptyForm.dates.push({
          ...returnedDates.dates,
          days: returnedDates.days,
          type: returnedDates.typeDialog
        })
        const lastVal = [ ...this.emptyForm.dates ]
        // this.emptyForm.dates = null
        // setTimeout(() => {
        // this.$nextTick(() => {
          // console.log('should set')
        this.emptyForm.dates = [ ...lastVal ].sort((a, b) => {
          if (a.type === 'day' && b.type === 'day' ) {
            if (a.days.val === b.days.val) {
              return moment(a.startTime, 'HH:mm').valueOf() - moment(b.startTime, 'HH:mm').valueOf()
            } else {
              return a.days.val - b.days.val
            }
          } else {
            if (a.type && b.type) {
              return a.type - b.type
            } else {
              if (!a.type) return 1
              if (!b.type) return -1
            }
          }
        }).sort((a, b) => {
          if (a.type && b.type) {
            return a.type - b.type
          } else {
            if (!a.type) return 1
            if (!b.type) return -1
          }
        }).map(task => ({ ...task, key: this.guid() }))
        // })
        // }, 100);
      }
    },
    save () {
      console.log('kajajajajaj')
      this.$emit('save', { data: this.emptyForm })
    },
    returnFormData () {
      console.log('kajajajajaj', this.emptyForm)
      return this.emptyForm
    },
    cancel () {
      this.$emit('cancel')
    },
    updateStartDateTime ({ date, time, i }) {
      console.log('kakakakakakadududu')
      this.emptyForm.dates[i].startDate = date
      this.emptyForm.dates[i].startTime = time
    },
    updateEndDateTime ({ date, time, i }) {
      this.emptyForm.dates[i].endDate = date
      this.emptyForm.dates[i].endTime = time
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.dataFetched = true
    })
  },
  created () {
    if (!this.isNewDates) {
      this.emptyForm.dates = []
      for (const dateInex in this.dates) {
        const dateEntry = this.dates[dateInex]
        if ((''+dateEntry.start_hour).length < 2) {
          dateEntry.start_hour = `0${dateEntry.start_hour}`
        }
        if ((''+dateEntry.start_minute).length < 2) {
          dateEntry.start_minute = `0${dateEntry.start_minute}`
        }
        if ((''+dateEntry.end_hour).length < 2) {
          dateEntry.end_hour = `0${dateEntry.end_hour}`
        }
        if ((''+dateEntry.end_minute).length < 2) {
          dateEntry.end_minute = `0${dateEntry.end_minute}`
        }
        if (dateEntry.start_month !== null) {
          const constructedStartDate = `${moment().format('YYYY')}-${dateEntry.start_month}-${dateEntry.start_day}`
          const constructedStartTime = `${dateEntry.start_hour}:${dateEntry.start_minute}`
          const constructedEndDate = `${moment().format('YYYY')}-${dateEntry.end_month}-${dateEntry.end_day}`
          const constructedEndTime = `${dateEntry.end_hour}:${dateEntry.end_minute}`

          this.emptyForm.dates.push({
            startDate: constructedStartDate,
            startTime: constructedStartTime,
            endDate: constructedEndDate,
            endTime: constructedEndTime
          })
        } else {
          const constructedStartTime = `${dateEntry.start_hour}:${dateEntry.start_minute}`
          const constructedEndTime = `${dateEntry.end_hour}:${dateEntry.end_minute}`
          const day = this.daysOptions.filter((day) => day.val === dateEntry.start_day)
          this.emptyForm.dates.push({
            type: 'day',
            startDate: null,
            startTime: constructedStartTime,
            endDate: null,
            endTime: constructedEndTime,
            days: {
              name: day[0].name,
              val: day[0].val
            }
          })
        }
      }
    }
    if (this.name) {
      this.emptyForm.name = this.name
    }
    if (this.description) {
      this.emptyForm.description = this.description
    }
    if (this.isActive) {
      this.emptyForm.is_active = this.isActive
    }

    this.dates.sort((a, b) => a.start_day - b.start_day)

  },
  watch: {
    name(val) {
      this.emptyForm.name = val
    },
    description(val) {
      this.emptyForm.description = val
    },
    isActive(val) {
      this.emptyForm.is_active = val
    }
  }
}
</script>
